import { jsx as r } from "react/jsx-runtime";
import { useRef as g, useState as c, useEffect as _ } from "react";
import { c as i } from "../clsx-OuTLNxxd.js";
import { T as u, b as C, h as p, g as B, a as f, d as y, c as h, e as q } from "../Table-DgW2JAG9.js";
import '../GridTable.css';const N = "_gridTableWrapper_1meoq_274", R = "_gridTable_1meoq_274", W = "_gridTableRow_1meoq_284", G = "_gridTableColumn_1meoq_288", M = "_gridTableCaption_1meoq_291", w = "_gridTableHeader_1meoq_292", F = "_gridTableBody_1meoq_293", H = "_gridTableFooter_1meoq_294", x = "_gridTableCell_1meoq_298", E = "_fullWidthMobile_1meoq_301", j = "_hasMultipleTableBodies_1meoq_310", v = "_mainColumn_1meoq_345", o = {
  gridTableWrapper: N,
  gridTable: R,
  gridTableRow: W,
  gridTableColumn: G,
  gridTableCaption: M,
  gridTableHeader: w,
  gridTableBody: F,
  gridTableFooter: H,
  gridTableCell: x,
  fullWidthMobile: E,
  hasMultipleTableBodies: j,
  mainColumn: v
}, d = ({ children: e, className: l, label: a, mobileColumns: s, ...T }) => {
  const t = g(null), [b, n] = c(1);
  return _(() => {
    if (t.current) {
      const m = t.current.getElementsByClassName(o.gridTableBody);
      n(m.length);
    }
  }, []), /* @__PURE__ */ r(
    "div",
    {
      "aria-label": a,
      className: o.gridTableWrapper,
      style: {
        "--gridWidth": b + 1,
        ...b === 1 ? { gridTemplateColumns: "auto" } : {},
        "--mobileColumns": s
      },
      children: /* @__PURE__ */ r(
        u,
        {
          className: i(o.gridTable, l, {
            [o.hasMultipleTableBodies]: b > 1
          }),
          ref: t,
          ...T,
          children: e
        }
      )
    }
  );
}, O = ({ children: e, className: l, ...a }) => /* @__PURE__ */ r(p, { className: i(o.gridTableRow, l), ...a, children: e }), S = ({ children: e, className: l, isMain: a, ...s }) => /* @__PURE__ */ r(
  y,
  {
    className: i(
      o.gridTableColumn,
      {
        [o.mainColumn]: a
      },
      l
    ),
    ...s,
    children: e
  }
), k = ({
  children: e,
  className: l,
  isFullWidthMobile: a,
  isMain: s,
  order: T,
  start: t,
  ...b
}) => /* @__PURE__ */ r(
  h,
  {
    className: i(
      o.gridTableCell,
      {
        [o.fullWidthMobile]: a,
        [o.mainColumn]: s
      },
      l
    ),
    style: { "--cellOrder": T, "--start": t },
    ...b,
    children: e
  }
), z = ({ children: e, className: l, ...a }) => /* @__PURE__ */ r(q, { ...a, className: i(o.gridTableFooter, l), children: e }), A = ({ children: e, className: l, ...a }) => /* @__PURE__ */ r(B, { ...a, className: i(o.gridTableHeader, l), children: e }), D = ({ children: e, className: l, ...a }) => /* @__PURE__ */ r(f, { className: i(o.gridTableBody, l), ...a, children: e }), I = ({ children: e, className: l, ...a }) => /* @__PURE__ */ r(C, { className: i(o.gridTableCaption, l), ...a, children: e });
d.Caption = I;
d.Row = O;
d.Head = A;
d.Body = D;
d.Column = S;
d.Cell = k;
d.Footer = z;
export {
  d as GridTable
};
